import { GridRowSelectionModel, GridSortItem } from "@mui/x-data-grid";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import { PatientName } from "../../../../../utils/util-components/UtilComponents";
import {
  formatDateTime,
  formatDate,
} from "../../../../../utils/date-time-utility";
import { DGT_Pagination, getTrimmedUuid } from "../../../../../utils/utils";
import {
  getReportColumns,
  REPORT_STATUS_MAP,
  REPORT_MODE_MAP,
} from "./appointment-report-constants";
import StatusChip from "../../../../../components/StatusChip";

interface AppointmentReportTableProps {
  rows: any[];
  rowCount: number;
  loading: boolean;
  pagination: DGT_Pagination;
  onPaginationChange: (model: DGT_Pagination) => void;
  gridSorting: GridSortItem[];
  onSortChange: (model: GridSortItem[]) => void;
  rowSelectionModel?: GridRowSelectionModel;
  onRowSelectionModelChange?: (model: GridRowSelectionModel) => void;
}

const renderStatusCell = ({ row }: any) => {
  const statusConfig = REPORT_STATUS_MAP[row?.status] ?? {
    label: row?.status ?? "-",
    color: "#999",
    bgColor: "#F5F5F5",
  };
  return (
    <StatusChip
      label={statusConfig.label}
      color={statusConfig.color}
      bgColor={statusConfig.bgColor}
    />
  );
};

const renderModeCell = ({ row }: any) => {
  const modeConfig = REPORT_MODE_MAP[row?.mode] ?? {
    label: row?.mode ?? "-",
    color: "#999",
    bgColor: "#F5F5F5",
  };
  return (
    <StatusChip
      label={modeConfig.label}
      color={modeConfig.color}
      bgColor={modeConfig.bgColor}
    />
  );
};

/** Falls back to "-" when the value is missing or blank. */
const withFallback = (value: any) => String(value ?? "").trim() || "-";

const renderPatientName = ({ row }: any) => (
  <PatientName
    name={row?.patientName}
    patientId={row?.patientUuid ?? ""}
    disableNavigate={!row?.patientUuid}
  />
);

const COLUMNS = getReportColumns(
  renderStatusCell,
  renderModeCell,
  renderPatientName
);

const AppointmentReportTable = ({
  rows,
  rowCount,
  loading,
  pagination,
  onPaginationChange,
  gridSorting,
  onSortChange,
  rowSelectionModel,
  onRowSelectionModelChange,
}: AppointmentReportTableProps) => {
  const formattedRows = (rows ?? []).map((row) => ({
    ...row,
    id: row?.uuid,
    appointmentId: getTrimmedUuid(row?.uuid),
    startTime: formatDateTime(row?.startTime) ?? "",
    scheduledOn: formatDate(row?.scheduledOn) ?? "",
    scheduleSource: row?.scheduledSource ?? "",
    locationName: withFallback(row?.locationName),
    insuranceName: withFallback(row?.insuranceName),
  }));

  return (
    <>
      <CustomDataGridV2
        rows={formattedRows}
        getRowId={(row) => row?.uuid ?? row?.id}
        columns={COLUMNS}
        rowCount={rowCount ?? 0}
        loading={loading}
        paginationModel={pagination}
        onPaginationModelChange={onPaginationChange}
        sortModel={gridSorting}
        onSortModelChange={onSortChange}
        checkboxSelection
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
      />
    </>
  );
};

export default AppointmentReportTable;
